import React from 'react';
import PropTypes from 'prop-types';
import Previewer from '@fiverr-private/attachments_preview/src/Previewer';
import { sendMixPanelEvent } from '@fiverr-private/attachments_preview/src/Utils/mixpanel/index';
import { OPEN_EXTERNAL_COLLABORATION } from './events';
import './style.scss';

const GROUP_TYPE = 'collaborators';

class ExternalSharing extends React.Component {
    componentDidMount() {
        const { linkType } = this.props;
        this.trackOpenedExternalCollaborationEvent(linkType);
    }

    trackOpenedExternalCollaborationEvent(linkType) {
        sendMixPanelEvent({
            eventName: OPEN_EXTERNAL_COLLABORATION,
            eventData: {
                source: linkType
            }
        });
    }

    render() {
        const {
            filerrIds,
            collaboratorId,
            contextId,
            contextType,
            linkType,
            unsubscribe,
            locale
        } = this.props;

        return (
            <div className="external-sharing">
                <Previewer filerrIds={filerrIds}
                    currentFilerrId={filerrIds[0]}
                    collaboratorId={collaboratorId}
                    withModalBehavior={false}
                    withCollaboration={true}
                    contextId={contextId}
                    contextType={contextType}
                    source={linkType}
                    unsubscribe={unsubscribe}
                    requiredGroupType={GROUP_TYPE}
                    groupType={GROUP_TYPE}
                    locale={locale}/>
            </div>
        );
    }
}

ExternalSharing.propTypes = {
    filerrIds: PropTypes.array.isRequired,
    collaboratorId: PropTypes.string.isRequired,
    contextId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    contextType: PropTypes.string.isRequired,
    unsubscribe: PropTypes.bool,
    locale: PropTypes.string
};

export default ExternalSharing;
